import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import React from 'react';
import IntlMessages from '../../../../util/IntlMessages';

const UserModal = ({ onClose, data }) => {
    return (
        <Dialog open={true} onClose={onClose} maxWidth={'sm'}>
            <DialogTitle id='form-dialog-title'>
                <strong className='d-block text-center'>
                    {/* Prioritizing camelCase (user collection) with fallback to snake_case (employee collection) */}
                    {/* This supports the future merge of users and employees where camelCase will be standard */}
                    {`${data?.firstName ?? data?.first_name} ${data?.lastName ?? data?.last_name}`}
                </strong>
            </DialogTitle>
            <DialogContent>
                <UserModalContent data={data} />
            </DialogContent>
        </Dialog>
    );
};

export const UserModalContent = ({ data }) => {
    return (
        <div className='h4'>
            <div className='mb-2'>
                <strong>
                    <IntlMessages id={'shared.role'} />:{' '}
                </strong>
                <span>{data.roles.join(', ')}</span>
            </div>
            {data.scope.productionLines &&
                data.scope.productionLines.length > 0 && (
                    <div className='mb-2'>
                        <strong>
                            <IntlMessages id={'shared.productionLine.plural'} />
                            :{' '}
                        </strong>
                        <span>
                            {data.scope.productionLines.map((line) => (
                                <Chip
                                    key={line}
                                    label={line}
                                    size='small'
                                    className={'mx-1'}
                                />
                            ))}
                        </span>
                    </div>
                )}
            {data.scope.sections && data.scope.sections.length > 0 && (
                <div className='mb-2'>
                    <strong>
                        <IntlMessages id={'shared.productionSection.plural'} />:{' '}
                    </strong>
                    <span>
                        {data.scope.sections.map((section) => (
                            <Chip
                                key={section}
                                label={section}
                                size='small'
                                className={'mx-1'}
                            />
                        ))}
                    </span>
                </div>
            )}
        </div>
    );
};

export default UserModal;
